var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperiencesUnits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3C0.5 1.89543 1.39543 1 2.5 1H19.0466C20.1511 1 21.0466 1.89543 21.0466 3V14.3169C20.3841 14.0341 19.6549 13.8776 18.8892 13.8776C15.8516 13.8776 13.3892 16.34 13.3892 19.3776C13.3892 20.6508 13.8218 21.823 14.5481 22.7552H2.5C1.39543 22.7552 0.5 21.8598 0.5 20.7552V3ZM5.03233 5.83448C4.53171 5.83448 4.12587 6.24032 4.12587 6.74095C4.12587 7.24158 4.53171 7.64742 5.03233 7.64742H16.5142C17.0149 7.64742 17.4207 7.24158 17.4207 6.74095C17.4207 6.24032 17.0149 5.83448 16.5142 5.83448H5.03233ZM4.12587 11.5754C4.12587 11.0748 4.53171 10.669 5.03233 10.669H16.5142C17.0149 10.669 17.4207 11.0748 17.4207 11.5754C17.4207 12.0761 17.0149 12.4819 16.5142 12.4819H5.03233C4.53171 12.4819 4.12587 12.0761 4.12587 11.5754ZM5.03233 15.5035C4.53171 15.5035 4.12587 15.9093 4.12587 16.4099C4.12587 16.9106 4.5317 17.3164 5.03233 17.3164H10.4711C10.9718 17.3164 11.3776 16.9106 11.3776 16.4099C11.3776 15.9093 10.9718 15.5035 10.4711 15.5035H5.03233Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6222 22.5177C18.3204 22.5505 18.0069 22.4513 17.7755 22.2199L15.7707 20.2151C15.3655 19.8099 15.3655 19.1529 15.7707 18.7476C16.176 18.3424 16.833 18.3424 17.2382 18.7476L18.6214 20.1308L21.8742 16.878C22.2795 16.4728 22.9365 16.4728 23.3417 16.878C23.747 17.2833 23.747 17.9403 23.3417 18.3455L19.4675 22.2197C19.2365 22.4508 18.9236 22.5501 18.6222 22.5177Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencesUnits);
export default __webpack_public_path__ + "static/media/experiences-units.078ae1bcdcbd923dfa38d45936a5c74c.svg";
export { ForwardRef as ReactComponent };